<template>
	<div>
		<!--
		<div class="home">
			<p class="subtitle"> Rechercher des solutions pour </p>
			<div class="categories">
				<div class="categorie" v-for='(k, v) in choices("categorie")' :key="k">
					<img :src="getImage(v)" :alt="k">
					<div class="categorie_icon">
						<img :src="getIcon(v)">
						<p v-html='getLabel(v)'></p>
					</div>
					<router-link tag='button' :to="{ name: 'list', query: {cat: v} }"  @click.native="pageChange(); stats(v)"> Voir les initiatives </router-link>
				</div>
				<div class="categorie add_initiative">
					<p class="subsubtitle"> Vous avez lancé une initiative ? </p>
					<p> Vous en connaissez une <br /> qui n'apparait pas sur le site ? <br /><br /> Aidez nous à répertorier  <br />toutes les initiatives  <br /> sur la Métropole ! </p>
					<router-link tag='button' :to="{ name: 'form' }" @click.native="pageChange()"> <span class="plus"> + </span> <span> publier une initiative</span> </router-link>
				</div>
			</div>
		</div>
		-->
		<img class="stats" src="../static/stats.png" alt="Statistiques de visite">
		<div class="other_sites">
			<p class="subtitle"> <b> La métropole continue de vous aider à travers ses plateformes </b> </p>
			<p class="undertitle"> Retrouvez nos services en ligne </p>
			<div class="other_sites_list">
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_GL.svg" alt="GrandLyon">
					<br />
					<img class="logo" src="../static/GL_black.svg" alt="GrandLyon">
					<p> Grandlyon.com, le site officiel de la Métropole de Lyon, les grands projets de cet été </p>
					<button><a href="https://www.grandlyon.com/pratique/la-metropole-sur-le-web.html" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_MET.svg" alt="MET">
					<br />
					<img class="logo" src="../static/MET.svg" alt="MET">
					<p> Restez informés 7/7 jours. <br /> Rendez vous sur met.grandlyon.com </p>
					<button><a href="https://met.grandlyon.com/" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_Toodego.svg" alt="Toodego">
					<br />
					<img class="logo" src="../static/toodego_black.svg" alt="Toodego">
					<p> La plateforme de vos démarches et de vos services de proximité </p>
					<button><a href="https://www.toodego.com/" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_laclasse.svg" alt="laclasse.com">
					<img class="logo" src="../static/laclasse.svg" alt="laclasse.com">
					<p> Espace Numérique de Travail des collèges et écoles de la Métropole de Lyon </p>
					<button><a href="laclasse.com/" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_data.svg" alt="Data Grand Lyon">
					<img class="logo" src="../static/data.png" alt="Data Grand Lyon">
					<p> Data.grandlyon.com est la plateforme d’accès aux données des acteurs du territoire métropolitain </p>
					<button><a href="https://data.grandlyon.com/accueil" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_LYVE.svg" alt="LYVE">
					<img class="logo" src="../static/LYVE.svg" alt="LYVE">
					<p> L'associé des entrepreneurs français <br /> Réseau, entraide, affaires, conseils </p>
					<button><a href="https://lyve-lyon.com/home" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_Onlymoov.svg" alt="Onlymoov">
					<img class="logo" src="../static/Onlymoov.svg" alt="Onlymoov">
					<p> Tous vos trajets en temps réel dans la métropole de Lyon </p>
					<button><a href="https://www.onlymoov.com/" target="_blank"> voir le site </a></button>
				</div>
				<div class="other_site">
					<img class="screenshot" src="../static/Screenshot_PATLY.svg" alt="PATLY">
					<img class="logo" src="../static/PATLY.png" alt="PATLY">
					<p> La plateforme de participation au Projet Alimentaire du Territoire Lyonnais </p>
					<button><a href="https://patly.org/" target="_blank"> voir le site </a></button>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import Store from '../utils/store.js'

var _paq = window._paq || [];

const IMAGE_PATH = {
    "1": "/Categorie_illustration1.jpg",
    "2": "Categorie_illustration2.jpg",
    "3": "Categorie_illustration3.jpg",
    "4": "Categorie_illustration4.jpg",
    "5": "Categorie_illustration5.jpg"
};
const ICON_PATH = {
    "1": "Courses-MangerLocal_1.svg",
    "2": "Scolarité.svg",
    "3": "Emploi.svg",
    "4": "/FormationCultureActivPhysique.svg",
    "5": "/producers.svg"

};
const LABELS = {
    "1": "Cartes des points de ventes, <br /> marchés solidaires, <br /> livraisons de paniers...",
    "2": "Des ressources éducatives, <br /> des conseils, <br />des communautés...",
    "3": "Groupes d'entraide, <br /> aides aux entreprises, <br /> solidarités...",
    "4": "Contenus culturels, <br /> idées d'activités, <br /> conseils...",
    "5": "Des ressources, <br /> des communautés, <br /> des solutions..."
};

export default {
    name: 'Home',
    data: function() {
        return {
            store: Store
        }
    },
	methods: {
        pageChange: function() {
            window.scrollTo(0, 0);
        },
        choices: function(field) {
            return this.store.metadata["fields"][field]["options"]["choices"];
        },
		getImage(id) {
			return IMAGE_PATH[id];
		},
		getIcon(id) {
			return ICON_PATH[id];
		},
		getLabel(id) {
			return LABELS[id];
		},
		stats: function(actionName) {
            _paq.push(["trackEvent", "Categories", actionName]);
        }
	}
}

</script>

<style scoped>

button{
    background-color: var(--medium-red);
    border: none;
    color: white;
    border-radius: 30px;
    font-weight: bold;
    padding: 2% 5%;
}

.subtitle{
	margin:0;
	padding: 1%;
	font-size: 1.6vw;
}

.undertitle{
	font-size: 1.2vw;
	margin: 0;
}

.subsubtitle{
	color: var(--medium-red);
	font-weight: 900;
}

.stats{
	width: 100%;
	background-color: #DCDCDC;
}



.other_sites{
	background: linear-gradient(180deg, #FFFFFF 0%, #DCDCDC 100%);
	box-sizing: border-box;
	padding: 2% 10%;
}

.other_sites_list{
	display:grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    padding-top: 2%;
}

.other_site{
	text-align: left;
	align-items: left;
	margin: 5%;
}

.screenshot{
	width: 100%;
}

.other_site img{
	margin-top: 2%;
}

.logo{
	height: 2vw;
}

a{
	text-decoration: none;
	color: white;
}


/* Mobile version */
@media (max-width: 600px) {

	.subtitle{
		font-size: 4vw;
	}
	.categories{
		display: inline-block;
	}

	.categorie_icon img{
		margin-left: 5%;
	}

	.add_initiative{
		padding: 10% 5%;
	}

	.other_sites_list{
		display: inline
	}

	.other_site button{
		margin-bottom: 5%;
	}

	.logo{
		height: 8vw;
	}

}

/*

.home{
	background-color: var(--almost-white);
	padding: 0 10%;
}


.categories{
	display:grid;
    grid-template-columns: repeat(3, 31%);
    justify-content: center;
}

.categorie{
	display: inline-block;
	background: white;
	border: 2px solid #EDEDED;
	box-sizing: border-box;
	margin: 5%;
	padding-bottom: 5%;
}

.categorie img{
	width: 100%;
}



.add_initiative{
	padding-top: 10%;
	border: 2px solid var(--medium-red);
}

.add_initiative p{
	margin-bottom: 10%;
}

.categorie_icon{
	display: flex;
	justify-content: center;
	text-align: left;
}

.categorie_icon img{
	margin-right: 10%;
	width: auto;
}

.add_initiative button{
	align-items: center;
    display: flex;
    margin: auto;
}

.plus{
	font-size: 1.5vw;
	margin-right: 1vw;
}
*/

</style>
